export function initLinkImg($) {
  /* ========================================================================= *\
  **  === GENERAL                                                              *| 
  \* ========================================================================= */

  var id;
  $('.link-img--img-container#img-0').addClass('is-active')
  $('.link-img--link a').each(function() {
    $(this).on('mouseover', function() {
      var img = $(this).data("img");
      $('.link-img--img-container').each(function() {
        id = $(this).attr('id');
        if(id == img) {
          $(this).addClass('is-active')
        } else {
          $(this).removeClass('is-active')
        }
      });
    });
  });
}
